import { legacy_createStore, combineReducers, applyMiddleware, compose } from "redux";
import { reducer as AdminReducer } from "./AdminReducer/reducer";
import { reducer as AuthReducer } from "./AuthReducer/reducer";
import thunk from "redux-thunk";

import contactUsReducer from "./Store/Slice/FormsData/contactUs";
import callBackReducer from "./Store/Slice/FormsData/callBack";
import bookAlternativeTherapiesReducer from "./Store/Slice/FormsData/BookAlternativeTherapies";
import calmYourEczemaNaturallyReducer from "./Store/Slice/FormsData/CalmYourEczemaNaturally"
import enrollInHealthPackageReducer from "./Store/Slice/FormsData/EnrollInHealthPackage";
import findYourQuestionsReducer from "./Store/Slice/FormsData/FindYourQuestions";
import shareYourThoughtsReducer from "./Store/Slice/FormsData/ShareYourThoughts";
import submitYourTestimonialReducer from "./Store/Slice/FormsData/SubmitYourTestimonial";
import DropDownReducer from "./Store/Slice/DropDown";
import MedicinesReducer from "./Store/Slice/Medicines";
import CustomFiledForPatients from "./Store/Slice/Patients";
import AppointmentsSlice from "./Store/Slice/Appointments";
import ShareLinksSlice from "./Store/Slice/ShareLinks";
import SubAilmentsReducer from "./Store/Slice/subAilments";

const rootReducer = combineReducers({
    AdminReducer: AdminReducer, // Provide a key ('admin') for AdminReducer
    AuthReducer: AuthReducer, // Provide a key ('auth') for AuthReducer

    contactUs: contactUsReducer, // Provide a key ('contactUs') for contactUsReducer
    callBack: callBackReducer, // Provide a key ('callBack') for callBackReducer
    bookAlternativeTherapies: bookAlternativeTherapiesReducer, // Provide a key ('bookAlternativeTherapies') for bookAlternativeTherapiesReducer
    calmYourEczemaNaturally: calmYourEczemaNaturallyReducer, // Provide a key ('calmYourEczemaNaturally') for calmYourEczemaNaturallyReducer
    enrollInHealthPackage: enrollInHealthPackageReducer, // Provide a key ('enrollInHealthPackage') for enrollInHealthPackageReducer
    findYourQuestions: findYourQuestionsReducer, // Provide a key ('findYourQuestions') for findYourQuestionsReducer
    shareYourThoughts: shareYourThoughtsReducer, // Provide a key ('shareYourThoughts') for shareYourThoughtsReducer
    submitYourTestimonial: submitYourTestimonialReducer, // Provide a key ('submitYourTestimonial') for submitYourTestimonialReducer
    dropDown: DropDownReducer, // Provide a key ('dropDown') for DropDownReducer
    medicines: MedicinesReducer, // Provide a key ('medicines') for MedicinesReducer
    customData: CustomFiledForPatients,
    Appointments: AppointmentsSlice,
    ShareLinks: ShareLinksSlice,
    SubAilments:SubAilmentsReducer
});




const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export const store = legacy_createStore(
    rootReducer,
    composeEnhancers(applyMiddleware(thunk))
);
